export default __webpack_public_path__ + "static/media/tv_netflix.62835e39.svg";